import InnerHTML from "dangerously-set-html-content";
import type { PlyrEvent } from "plyr";
import type { CoursesLesson } from "@/react/types/CoursesLesson";
import { TipTapBlockEditor } from "@circle-react-uikit/TipTapBlockEditor";
import { TranscriptsPlayer } from "@circle-react-uikit/TranscriptsPlayer";

interface LessonContentProps {
  lesson: CoursesLesson;
  onFeaturedMediaProgress: (event: PlyrEvent) => void;
}
export const LessonContent = ({
  lesson,
  onFeaturedMediaProgress,
}: LessonContentProps) => {
  const isAudio = lesson.featured_media?.content_type.includes("audio");

  return (
    <>
      {lesson.featured_media_enabled && lesson.featured_media?.playback_url && (
        <TranscriptsPlayer
          src={lesson.featured_media.playback_url}
          isDownloadable={lesson.featured_media.is_downloadable}
          type={lesson.featured_media.content_type}
          downloadUrl={lesson.featured_media.url}
          mediaTranscriptId={lesson.featured_media.media_transcript_id}
          signedId={lesson.featured_media.signed_id}
          poster={lesson.featured_media?.thumbnail_image_url}
          preload="auto"
          menuPosition={isAudio ? "bottom" : "top"}
          onProgress={onFeaturedMediaProgress}
        />
      )}
      {lesson.featured_media_enabled && lesson.featured_media_embed && (
        <div className="flex items-start">
          <InnerHTML
            className="flex-1 [&>iframe]:aspect-video [&>iframe]:h-auto [&>iframe]:max-w-full"
            html={lesson.featured_media_embed.html}
          />
        </div>
      )}
      <TipTapBlockEditor
        readOnly
        disabledExtensions={["mention", "poll", "ai_copilot"]}
        value={lesson.rich_text_body.body}
        sgidToObjectMap={lesson.rich_text_body.sgids_to_object_map}
        inlineAttachments={lesson.rich_text_body.inline_attachments}
      />
    </>
  );
};
